/**
 * @file
 * Search.
 */

var Drupal = Drupal || {};

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.search = {
    attach: function(context) {
      var search = $('.search-block-form');
      var menu_item = $('#block-mainnavigation > ul > li:last-child');
      var menu_item_mobile = $('nav.slicknav_nav > ul > li:last-child');

      menu_item.prepend(search);
      menu_item_mobile.prepend(search);

      search = $('#block-mainnavigation .search-block-form');
      search.hide();

      menu_item.find('a').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('open');
        search.toggle();
      });
    }
  };
})(jQuery, Drupal);
